import CloseIcon from "@mui/icons-material/Close"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Grid from "@mui/material/Unstable_Grid2"
import React, { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"

import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"

import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"

import CustomTextField from "../CustomTextField"

import { DialogTitle, IconButton } from "@mui/material"
import { tipoNovedadPago } from "../../Redux/novedadesLiquidacion"
import TokenContext from "../../context/TokenContext"
import CustomSearchSelect from "../CustomSearchSelect"
import { obtenerDvisas } from "../../Redux/autocompletados"
import { useState } from "react"
import { useEffect } from "react"

const opcionesPorcentaje = [
  { value: "10", label: "10%" },
  { value: "20", label: "20%" },
  { value: "30", label: "30%" },
  { value: "40", label: "40%" },
  { value: "50", label: "50%" },
  { value: "60", label: "60%" },
  { value: "70", label: "70%" },
  { value: "80", label: "80%" },
  { value: "90", label: "90%" },
  { value: "100", label: "100%" },
]

const opcionesRanking = [
  { value: 100000000, label: "1 PLUS" },
  { value: 100000001, label: "1" },
  { value: 100000002, label: "2" },
  { value: 100000003, label: "3" },
  { value: 100000004, label: "4" },
]

const ModalSolicitudLiquidacion = ({ open, handleClose, onSubmit }) => {
  const dispatch = useDispatch()
  const token = useContext(TokenContext)
  const [fullWidth, setFullWidth] = useState(true)
  const [maxWidth, setMaxWidth] = useState("md")
  const [tipoNovedadP, setTipoNovedadP] = useState([]);
  const [divisas, setDivisas] = useState([])

  const tipoNovedadPSelector = useSelector((store) => store.novedadesLiquidacion.tipoNovedadPago)
  const loadSolicitarLiquidacion = useSelector((store) => store.novedadesLiquidacion.loadSolicitarLiquidacion)
  const divisasSelector = useSelector((store) => store.autocompletados.divisas);

  const defaultValues = {
    novedadDePago: null,
    tipoDeNovedadDePago: null,
    cantidadHoras: null,
    cantidad: null,
    porcentaje: null,
    importe: null,
    puestoRanking: null
  }

  const validacionSchema = yup.object().shape({
    tipoDeNovedadDePago: yup.object({ value: yup.string().required("Por favor seleccione el tipo de novedad de pago") }),
  })

  const { setValue, handleSubmit, ...methods } = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const tipoDeNovedadDePago = methods.watch('tipoDeNovedadDePago')
  const novedadDePago = methods.watch('novedadDePago')


  React.useEffect(() => {
    if (token) {
      dispatch(tipoNovedadPago(token))
      dispatch(obtenerDvisas(token))
    }
  }, [token])

  React.useEffect(() => {
    if (tipoNovedadPSelector.length > 0) {
      var arrayTipoNovedad = []
      tipoNovedadPSelector.forEach((tipo) => {
        var objetoTipo = {
          label: tipo.new_name,
          value: tipo.new_tipodenovedaddepagoid,
        }
        arrayTipoNovedad.push(objetoTipo)
      })
      setTipoNovedadP(arrayTipoNovedad)
    }
  }, [tipoNovedadPSelector])

  React.useEffect(() => {
    if (divisasSelector.length > 0) {
      var array = []
      divisasSelector.forEach((tipo) => {
        var objeto = {
          label: tipo.currencyname,
          value: tipo.transactioncurrencyid,
        }
        array.push(objeto)
      })
      setDivisas(array)

      const defaultValue = divisasSelector.find(tipo => tipo.transactioncurrencyid == "28843b8a-3ff0-ea11-a815-000d3ac073da");
      if (defaultValue) {
        setValue("divisa", { label: defaultValue.currencyname, value: defaultValue.transactioncurrencyid });
      }
    }
  }, [divisasSelector])

  useEffect(() => {
    // Establece los valores a null cuando novedadDePago cambia
    setValue('cantidadHoras', null);
    setValue('cantidad', null);
    setValue('porcentaje', null);
    setValue('importe', null);
    setValue('puestoRanking', null);
  }, [novedadDePago, methods]);

  const renderCamposSegunNovedad = () => {
    switch (novedadDePago?.value) {
      //Puesto en el ranking
      case 100000000:
        return (
          <>
            <Grid item xs={12} md={4} sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesRanking}
                req="true"
                type="text"
                name="puestoRanking"
                lab="Escala En Ranking"
                helperText="Por favor seleccione una opción"
              />
            </Grid>
            <Grid item xs={12} md={4} sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} name="importe" label="Importe" type="number" />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0 }}>
                <CustomSearchSelect options={divisas} type="text" name="divisa" lab="Divisa" />
              </Grid>
          </>
        );
      //Porcentaje
      case 100000001:
        return (
          <>
            <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect options={opcionesPorcentaje} type="text" name="porcentaje" lab="Porcentaje" />
            </Grid>
            <Grid item xs={12} md={4} sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} name="importe" label="Importe" type="number" />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0 }}>
                <CustomSearchSelect options={divisas} type="text" name="divisa" lab="Divisa" />
              </Grid>
          </>
        );
      //Cantidad de Horas
      case 100000002:
        return (
          <>
            <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} name="cantidadHoras" label="Cantidad Horas" type="number" />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0, visibility: "hidden"}}>
              <CustomSearchSelect options={divisas} type="text" name="divisa" lab="Divisa"/>
            </Grid>
          </>
        );
      //Cantidad
      case 100000003:
        return (
          <>
            <Grid item xs={12} md={4} sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} name="cantidad" label="Cantidad" type="number" />
            </Grid>
          </>
        );
      //Importe
      case 100000004:
        return (
          <>
            <Grid item xs={12} md={12} sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} name="importe" label="Importe" type="number" />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0 }}>
                <CustomSearchSelect options={divisas} type="text" name="divisa" lab="Divisa" />
              </Grid>
          </>
        );
      default:
        return null; // No se muestra ningún campo por defecto
    }
  };

  const submitDatos = (datos) => {
    onSubmit(datos)
  }

  useEffect(() => {
    if (tipoDeNovedadDePago) {
      // Filtrar opciones del segundo select según la selección del primero
      const filteredOptions = tipoNovedadPSelector.filter(
        (option) => option.new_name === tipoDeNovedadDePago.label
      );
      const arrayInforma = filteredOptions.map((element) => ({
        value: element.new_informa,
        label: element["new_informa@OData.Community.Display.V1.FormattedValue"]
      }));
      setValue('novedadDePago', arrayInforma[0]); // Establece las nuevas opciones
    }
  }, [tipoDeNovedadDePago, tipoNovedadPSelector, setValue]);



  return (
    <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={open} onClose={handleClose}>
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0 }}>
                <CustomSearchSelect
                  options={tipoNovedadP}
                  req="true"
                  type="text"
                  name="tipoDeNovedadDePago"
                  lab="Tipo de novedad de pago"
                  helperText="Por favor seleccione el tipo de novedad"
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0 }}>
                <CustomSearchSelect
                  options={[]}
                  req="true"
                  type="text"
                  name="novedadDePago"
                  lab="Informa"
                  helperText="Por favor seleccione el tipo de novedad de pago"
                  disabled={true}
                />
              </Grid>
              {/* Renderizar campos específicos según el valor de novedadDePago */}
              {renderCamposSegunNovedad()}
              <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0, my: 2 }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  // sx={buttonSx}
                  disabled={loadSolicitarLiquidacion === "LOADING"}
                  onClick={handleSubmit(submitDatos)}
                >
                  Enviar
                </Button>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSolicitudLiquidacion
